const banner = document.querySelector('[data-geo-suggestion]');
const configElement = document.querySelector('[data-geo-suggestion-config]');

const COOKIE = 'mwc_region_choice';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
const LEGACY_OPT_OUT = 'disabled_redirect';

// Geographic Europe, replacing ipstack `continent_name === 'Europe'` test.
// GB is handled separately because it routes to its own store.
// RU is deliberately absent: the EU shop does not serve Russia.
const EUROPE = [
  'AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ', 'DE', 'DK',
  'EE', 'ES', 'FI', 'FO', 'FR', 'GG', 'GI', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS',
  'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO',
  'PL', 'PT', 'RO', 'RS', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TR', 'UA', 'VA', 'XK',
];

const NORTH_AMERICA = ['US', 'CA', 'MX'];

function readCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];
}

// Omitting max-age makes it a session cookie, which is how "asked and declined"
// is distinguished from "chose a region" without a second cookie.
function writeCookie(name, value, maxAge) {
  const lifetime = maxAge ? `; max-age=${maxAge}` : '';
  document.cookie = `${name}=${value}; path=/${lifetime}; SameSite=Lax`;
}

function readLegacyOptOut() {
  try {
    return localStorage.getItem(LEGACY_OPT_OUT) === 'true';
  } catch {
    return false;
  }
}

function writeLegacyOptOut() {
  try {
    localStorage.setItem(LEGACY_OPT_OUT, 'true');
  } catch {
    // Private browsing — the cookie still records the choice.
  }
}

// An explicit region choice persists for a year.
function remember(region) {
  writeCookie(COOKIE, region, COOKIE_MAX_AGE);
}

// Declining is session-scoped, so a later session asks again.
function dismissForSession() {
  writeCookie(COOKIE, 'www');
}

// `?disabled_redirect` stays a permanent opt-out.
function optOutPermanently() {
  writeCookie(COOKIE, 'www', COOKIE_MAX_AGE);
  writeLegacyOptOut();
}

function consumeOptOutParam() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(LEGACY_OPT_OUT)) return false;

  url.searchParams.delete(LEGACY_OPT_OUT);
  history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  return true;
}

function regionFor(countryCode) {
  if (!countryCode || NORTH_AMERICA.includes(countryCode)) return null;
  if (countryCode === 'GB') return 'uk';
  if (EUROPE.includes(countryCode)) return 'eu';
  return null;
}

async function detect(root) {
  try {
    const response = await fetch(`${root.replace(/\/?$/, '/')}browsing_context_suggestions.json?country[enabled]=true`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;

    const data = await response.json();
    return data?.detected_values?.country ?? null;
  } catch {
    return null;
  }
}

// The element already holds the translated template; only the tokens are swapped.
function fill(element, replacements) {
  element.textContent = Object.entries(replacements).reduce(
    (text, [token, value]) => text.replaceAll(`||${token}||`, value),
    element.textContent.trim()
  );
}

function reveal(config, region, countryName) {
  const target = config.regions[region];
  const label = region === 'uk' ? banner.dataset.labelUk : banner.dataset.labelEu;
  const store = region === 'uk' ? banner.dataset.storeUk : banner.dataset.storeEu;
  if (!target) return;

  const deepLink = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const confirm = banner.querySelector('[data-geo-suggestion-confirm]');

  fill(banner.querySelector('[data-geo-suggestion-title]'), { country: countryName || label });
  fill(banner.querySelector('[data-geo-suggestion-text]'), { region: label, store });
  fill(confirm, { region: label, store });

  confirm.href = `${target.url}${deepLink}`;
  confirm.addEventListener('click', () => remember(region));

  banner.querySelectorAll('[data-geo-suggestion-dismiss]').forEach((button) => {
    button.addEventListener('click', () => {
      dismissForSession();
      banner.hidden = true;
    });
  });

  banner.hidden = false;
}

if (banner && configElement) {
  const config = JSON.parse(configElement.textContent);

  if (consumeOptOutParam()) optOutPermanently();

  const hasChoice = Boolean(readCookie(COOKIE)) || readLegacyOptOut();
  const isBlog = /\/blogs(\/|$)/.test(window.location.pathname);

  if (!hasChoice && !isBlog) {
    if (config.preferredRegion) {
      reveal(config, config.preferredRegion, null);
    } else {
      const country = await detect(config.root);
      const region = regionFor(country?.handle);
      if (region) reveal(config, region, country.name);
    }
  }
}
